import React from 'react';
import PropTypes from 'prop-types';

const StaticBuilderBackButton = props => (
  <button
    type="button"
    onClick={props.onBack}
    data-loading-text="Saving..."
    data-finishing-text="Finishing..."
    className="backButton pull-left btn btn-large"
    id="staticBackButton"
  >
    Back
  </button>
);

StaticBuilderBackButton.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default StaticBuilderBackButton;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderBackButton.jsx